declare namespace $ {

	export class $shm_hitalama_form_submit extends $mol_button_major {
		dom_name( ): string
	}
	
}

//# sourceMappingURL=submit.view.tree.d.ts.map